import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { TimesheetWorkedTimeBlockFragment } from 'generated/resources/graphql'

import AnimatedBox from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/components/AnimatedBox'
import { CustomTimeRangeCategory } from 'modules/time_categories_settings/hooks/useFetchTimeSettingsCustomTimeRangeCategories'

import DateWithValue from './DateWithValue'
import Header from './Header'

interface Props {
  category?: CustomTimeRangeCategory
  open: Record<string, boolean>
  toggleOpen: (name: string) => void
  workedTimeBlocks: TimesheetWorkedTimeBlockFragment[]
}

const BlocksBreakdown = ({ category, open, toggleOpen, workedTimeBlocks }: Props) => {
  if (!category) return <></>

  const { id, name } = category
  const isIdOpen = open[name]
  const minutes = workedTimeBlocks.reduce((acc, block) => acc + (block.minutes || 0), 0)
  const blocksByDate: Record<string, number> = {}

  workedTimeBlocks.forEach((block) => {
    const { date } = block

    if (!blocksByDate[date]) blocksByDate[date] = 0
    blocksByDate[date] += block.minutes || 0
  })

  return (
    <Box key={id} paddingLeft="s2" gap="s4" paddingBottom={isIdOpen ? 's8' : undefined}>
      <Header name={name} minutes={minutes} open={open} toggleOpen={toggleOpen} />
      <AnimatedBox isOpen={isIdOpen ?? false}>
        {isIdOpen &&
          Object.keys(blocksByDate).map((date) => (
            <DateWithValue key={date} date={date} minutes={blocksByDate[date] || 0} />
          ))}
      </AnimatedBox>
    </Box>
  )
}

export default BlocksBreakdown
